module.exports = __webpack_public_path__ + "static/profile-pic-0fa0f7d54a3be817d4022d8e466efef3.jpeg";